import styled from 'styled-components';
import bkBtn from 'src/assets/images/user-mobile/BackBtn2.svg';
import { useNavigate } from 'react-router-dom';
import { BkBtn } from 'src/styles/user-mobile/TopFixedBarStyle';

function EmptyTopFixedBarMap({ topText }: { topText: string }) {
  const navigate = useNavigate();

  return (
    <Container>
      <Back
        src={bkBtn}
        onClick={() => {
          navigate(-1);
        }}
      />

      <h1>{topText}</h1>
    </Container>
  );
}

export default EmptyTopFixedBarMap;

const Container = styled.div`
  width: 100%;
  height: 48px;
  position: absolute;
  z-index: 1005;
  flex-shrink: 0;
  border-bottom: 1px solid #dadada;
  background: #fff;

  display: flex;
  align-items: center;

  h1 {
    color: #111;
    font-size: 18px;
    font-weight: 700;
    line-height: 26px; /* 144.444% */
  }
`;
const Back = styled(BkBtn)`
  margin-left: 16px;
`;
